module.exports = __webpack_public_path__ + "static/media/todayBadge.bf5f9c8d.svg";